module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "ecosystem",
    class: _vm.padded
  }, [_c('div', {
    staticClass: "background ecosystem__background"
  }, [_c('h3', {
    staticClass: "background__banner ecosystem__banner",
    class: _vm.classes
  }, [_vm._v(_vm._s(_vm.content.banner))]), _vm._v(" "), _c('background-vector', {
    staticClass: "ecosystem__vector",
    attrs: {
      "animated": true,
      "images": _vm.logos,
      "hide-images": _vm.hideLogos,
      "scale": _vm.background.scale,
      "viewbox": _vm.background.viewbox
    },
    on: {
      "vector-ready": function($event) {
        _vm.ready = true
      }
    }
  })], 1), _vm._v(" "), (!_vm.mobile) ? _c('div', {
    staticClass: "ecosystem__cta",
    class: (_vm.hideLogos) ? 'ecosystem__cta--hidden' : ''
  }, [_c('router-link', {
    staticClass: "button button--border",
    attrs: {
      "to": "/ecosysteme/details"
    }
  }, [_c('svg', {
    staticClass: "button__border"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#button-border"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "button__label"
  }, [_vm._v(_vm._s(_vm.content.label))])])], 1) : _c('ul', {
    staticClass: "ecosystem__list",
    class: (_vm.hideLogos) ? 'ecosystem__list--hidden' : ''
  }, [_vm._l((_vm.content.logos), function(logo) {
    return _c('router-link', {
      staticClass: "ecosystem__logo",
      attrs: {
        "tag": "li",
        "to": ("/ecosysteme/" + (logo.path))
      }
    }, [_c('img', {
      attrs: {
        "src": logo.image.url,
        "alt": logo.image.alt
      }
    })])
  }), _vm._v(" "), _c('li', {
    staticClass: "ecosystem__logo ecosystem__cta"
  }, [_c('router-link', {
    staticClass: "button button--border",
    attrs: {
      "to": "/ecosysteme/details"
    }
  }, [_c('svg', {
    staticClass: "button__border"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#button-border"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "button__label"
  }, [_vm._v(_vm._s(_vm.content.label))])])], 1)], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "entity"
    }
  }, [(_vm.ready) ? _c('router-view', {
    attrs: {
      "details": _vm.details
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('header-nav', {
    attrs: {
      "modifier": "ecosystem"
    }
  }), _vm._v(" "), _c('footer-nav', {
    attrs: {
      "modifier": "ecosystem",
      "sidebars": _vm.sidebars
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-94d1d488!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/ecosystem/Ecosystem.vue
// module id = 647
// module chunks = 1